export default "__VITE_ASSET__2b998777__"